import productApi from "@/api/product";
import declare from "@/api/declare";
import category from "@/api/category";
import nation from "@/api/nation";
import { formatCategories } from "@/utils/common";

const product = {
  state: {
    declareList: [],
  },
  mutations: {
    setDeclareList(state, data) {
      state.declareList = data;
    },
  },
  actions: {
    queryDeclareOrderList({ commit }, data) {
      return declare.queryDeclareOrderList(data).then((res) => {
        //commit("setDeclareList", res.result);
        return res;
      });
    },
    declareList({ commit }, data) {
      return declare.list(data).then((res) => {
        //commit("setDeclareList", res.result);
        return res;
      });
    },
    declareDetail({ commit }, data) {
      return declare.detail(data).then((res) => {
        return res;
      });
    },
    restApply({ commit }, data) {
      return declare.restApply(data).then((res) => res);
    },
    restTpl({ commit }, data) {
      return declare.restTpl(data).then((res) => res);
    },
    restPort({ commit }, data) {
      return declare.restPort(data).then((res) => res);
    },
    reMailNo({ commit }, data) {
      return declare.reMailNo(data).then((res) => res);
    },
    reWms({ commit }, data) {
      return declare.reWms(data).then((res) => res);
    },
    cancelStockout({ commit }, data) {
      return declare.cancelStockout(data).then((res) => res);
    },
    downloadDeclareList({ commit }, data) {
      return declare.downloadDeclareList(data).then((res) => res);
    },
    submitCustomsDeclareOrderBuildExcelTask({ commit }, data) {
      return declare
        .submitCustomsDeclareOrderBuildExcelTask(data)
        .then((res) => res);
    },
    updateBusinessState({ commit }, data) {
      return declare.updateBusinessState(data).then((res) => res);
    },
    updateStockoutOrderInfo({ commit }, data) {
      return declare.updateStockoutOrderInfo(data).then((res) => res);
    },
    updateStcokoutOrderSku({ commit }, data) {
      return declare.updateStcokoutOrderSku(data).then((res) => res);
    },
    auditStockoutOrder({ commit }, data) {
      return declare.auditStockoutOrder(data).then((res) => res);
    },
    systemRunInfo({ commit }, data) {
      return declare.systemRunInfo(data).then((res) => res);
    },
    uploadNuclearNoteExcel({ commit }, data) {
      return declare.uploadNuclearNoteExcel(data).then((res) => res);
    },
    orderSplitByAccountBook({ commit }, data) {
      return declare.orderSplitByAccountBook(data).then((res) => res);
    },
    submitNuclareBuildExcelTask({ commit }, data) {
      return declare.submitNuclareBuildExcelTask(data).then((res) => res);
    },
    submitCustomsDeclareOrderDetailTask({ commit }, data) {
      return declare
        .submitCustomsDeclareOrderDetailTask(data)
        .then((res) => res);
    },
    reSendNotifyMessage({ commit }, data) {
      return declare.reSendNotifyMessage(data).then((res) => res);
    },
    tagNoNeedLowDeclare({ commit }, data) {
      return declare.tagNoNeedLowDeclare(data).then((res) => res);
    },
    previewDeclareOrderImport({ commit }, data) {
      return declare.previewDeclareOrderImport(data).then((res) => res);
    },
    batchImportDeclareOrder({ commit }, data) {
      return declare.batchImportDeclareOrder(data).then((res) => res);
    },
  },
};

export default product;
